import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format.js';
import { pixelsToRem } from '~/theme/typography';

type SingleLineValueProps = {
  title: string;
  value?: string | number;
  isCurrency?: boolean;
};

export default function SingleLineValue({
  title,
  value,
  isCurrency = false,
}: Readonly<SingleLineValueProps>) {
  const toRender = isCurrency ? formatCurrency(value) : value;
  const fontSize = pixelsToRem(14);

  return (
    <Flex mb="8px" as="dl">
      <Text fontSize={fontSize} fontWeight="bold" d="inline" pr={3} as="dt">
        {title}
      </Text>
      <Text fontSize={fontSize} d="inline" as="dd">
        {toRender}
      </Text>
    </Flex>
  );
}
